import { Box, Button, Container, Divider, Paper, Stack, Typography, useTheme, Grid } from '@mui/material';
import TermsCheckbox from '../../../components/TermsCheckbox';
import AnimationPage from '../../AnimationPage';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import { FormInputText } from '../../../form-components/FormInputText';
import { useForm } from 'react-hook-form';

const initialTermsAll = {
  term1: true,
  term2: true,
  term3: true,
};

const initialTerms = {
  term1: false,
  term2: false,
  term3: false,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '800px',
  maxHeight: '800px',
  bgcolor: 'background.paper',
  border: '2px solid #0F7F85',
  padding: '20px',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

const EmailResponse = ({ username }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [terms, setTerms] = useState(initialTerms);
  const [all, setAll] = useState(false);
  const [termNumber, setTermNumber] = useState(null);

  const {
    control,
    reset,
    handleSubmit,
    setError,
    watch,
    getValues,
    formState: { errors },
  } = useForm({});
  return (
    <Box sx={{ display: 'flex', mt: 4 }}>
      <Box sx={{ m: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '670px',
            maxHeight: '160px',
            background: '#F5F5F5',
            padding: '60px 120px',
            borderRadius: '16px',
            color: '#111111',
          }}>
          <Stack ml="6px">
            <Typography sx={{ fontWeight: '400', fontSize: '17px', textAlign: 'center', mb: '5px' }}>
              회원님의 아이디는
            </Typography>
            <Typography sx={{ fontWeight: 'bold', fontSize: '17px', textAlign: 'center' }}>{username}</Typography>
            <Typography sx={{ fontWeight: '400', fontSize: '17px', textAlign: 'center' }}>입니다.</Typography>
          </Stack>
        </Box>
        <Box style={{ height: '140px', width: '100%' }}></Box>
      </Box>
    </Box>
  );
};

export default EmailResponse;
